'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpaceType = exports.Space = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _objectValues = require('object-values');

var _objectValues2 = _interopRequireDefault(_objectValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SpaceType = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
};

var parseSpaceProps = function parseSpaceProps(_ref) {
  var step = _ref.step,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? SpaceType.VERTICAL : _ref$type,
      _ref$value = _ref.value,
      value = _ref$value === undefined ? 0 : _ref$value,
      x = _ref.x,
      y = _ref.y,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ['step', 'type', 'value', 'x', 'y', 'className']);

  var style = {};

  if (x || type === SpaceType.HORIZONTAL) {
    style.display = 'inline-block';
    style.width = x;
  } else if (y || type === SpaceType.VERTICAL) {
    style.display = 'block';
    style.height = y;
  }

  return _extends({ className: (0, _classnames2.default)('Space', className), style: style }, props);
};

var Space = function Space(_ref2) {
  var _ref2$is = _ref2.is,
      is = _ref2$is === undefined ? 'div' : _ref2$is,
      props = _objectWithoutProperties(_ref2, ['is']);

  return _react2.default.createElement(is, parseSpaceProps(props));
};

Space.propTypes = {
  type: _propTypes2.default.oneOf((0, _objectValues2.default)(SpaceType)),
  is: _propTypes2.default.string,
  x: _propTypes2.default.number,
  y: _propTypes2.default.number,
  value: _propTypes2.default.number /* px value */
};

Space.displayName = 'Space';

exports.Space = Space;
exports.SpaceType = SpaceType;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Space.js
// module id = 1134
// module chunks = 0